export default __webpack_public_path__ + "static/media/map5.a12ce8b5.png";